import { useState, useEffect, useContext } from "react";
import { userContext } from "./component/context/";
import returnStr from "./component/vocabs";
import {
  Main,
  Holder,
  Cn,
  GetPhoneNumber,
  Mobile,
  Dots,
  Iot,
  HalfMobile,
  SmartHome,
  Warning,
  Section1,
  Section2,
  Section3,
  Section4,
  Section5,
  ContactUs,
  ScrollDown,
} from "./component/E/index";
import Logo from "./assets/images/logo.png";
import Bell_logo from "./assets/images/bell.png";
import Chart_logo from "./assets/images/chart.png";
import Home_back from "./assets/images/home.jpg";
import SpeedLogo from "./assets/images/speed.png";
import Login_back from "./assets/images/login-back.png";
import "./App.css";
import styled from "styled-components";

function App() {
  const { isFa } = useContext(userContext);
  const [height, setHeight] = useState(window.innerHeight);
  const [effected, setEffected] = useState(false);
  const [step, setStep] = useState(0);
  const [statusBar, setStatusBar] = useState("var(--blue)");
  const vocabs = (str) => {
    return returnStr(str, isFa);
  };

  useEffect(() => {
    if (!effected) {
      setEffected(true);
      window.addEventListener("scroll", (e) => {
        setStep((window.scrollY / window.innerHeight).toFixed(0));
      });
    }
  }, []);

  return (
    <Main style={{ direction: isFa ? "rtl" : "ltr" }}>
      <Dots step={step}></Dots>
      <Holder
        timer={11000}
        step={step}
        id="0"
        hieght={height}
        desc={vocabs("s1_description")}
        title={vocabs("s1_title")}
        logo={Logo}
        appLogo={true}
        iconColor={"#7cc2dd"}
        mobileColor={"var(--lightBlue)"}
        statusBar={"white"}
        mobileComponent={<Section1 />}
      >
        <GetPhoneNumber />
      </Holder>
      <Holder
        timer={18000}
        step={step}
        id="1"
        hieght={height}
        desc={vocabs("s2_description")}
        title={vocabs("s2_title")}
        logo={SpeedLogo}
        appLogo={false}
        mobileColor={"var(--blue)"}
        statusBar={statusBar}
        mobileComponent={<Section2 changeStatusBar={setStatusBar} />}
      ></Holder>
      <Holder
        timer={10000}
        step={step}
        id="2"
        hieght={height}
        desc={vocabs("s3_description")}
        title={vocabs("s3_title")}
        logo={Bell_logo}
        appLogo={false}
        mobileColor={"var(--red)"}
        statusBar={"var(--red)"}
        mobileComponent={<Section3 />}
      ></Holder>
      <Holder
        timer={10000}
        step={step}
        id="3"
        hieght={height}
        desc={vocabs("s4_description")}
        title={vocabs("s4_title")}
        logo={Chart_logo}
        appLogo={false}
        mobileColor={"var(--purple)"}
        statusBar={"var(--blue)"}
        mobileComponent={<Section4 />}
      ></Holder>
      <SmartHome
        id="4"
        step={step}
        statusBar={"var(--blue)"}
        mobileComponent={<Section5 />}
      />
      <Iot id="5" />
      <ContactUs id="6" />
    </Main>
  );
}

export default App;
